import React from 'react';
import { Row, Col } from 'reactstrap';

const OrderTabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <Row className="g-1 flex-nowrap text-nowrap gx-3 overflow-x-auto">
      {tabs.map((tab, index) => (
        <Col key={index} className="text-center">
          <div
            style={{
              backgroundColor: "#ffffff",
              paddingBlock: activeTab === tab ? "calc(.8rem - 4px)" : ".8rem",
              paddingInline: '1rem',
              borderBlock: activeTab === tab ? "4px solid #FBBD34" : "none",
              fontWeight: 500,
              fontSize: "1.25rem",
              cursor: "pointer",
              transition: "padding-block 0.3s ease, border-block 0.3s ease"
            }}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default OrderTabs;
